import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Overlay from '../../../forms/_common/Overlay';
import { useQueryMutation } from '../../../../hooks/@lore/query-connect';
import Intent from '../educator-intent-school/Intent';

PartnerIntentNo.propTypes = {
  userIntents: PropTypes.object
};

export default function PartnerIntentNo(props) {
  const {
    user,
    intents,
    userIntents,
    onSubmit,
    title = `Not right now.`
  } = props;

  const partnerIntent = _.find(intents.data, intent => intent.data.name === 'Partner');

  const isPartner = !!_.find(userIntents.data, intent => intent.data.id === partnerIntent.id);

  const mutation_create = useQueryMutation('tagNode.create');
  const mutation_destroy = useQueryMutation('tagNode.destroy2');

  const saving = (
    mutation_create.isLoading ||
    mutation_destroy.isLoading
  );

  function onToggleIntent(intent) {
    const userIntent = _.find(userIntents.data, function(userIntent) {
      return userIntent._tag.id === intent.id;
    });

    if (!userIntent) {
      mutation_create.mutate({
        userId: user.id,
        tagId: intent.id
      }, {
        onSuccess: payload => {
          userIntents._add(payload);
          onSubmit();
        }
      });
    } else {
      mutation_destroy.mutate(userIntent._tagNode, {
        onSuccess: payload => {
          userIntents._remove(payload);
          onSubmit();
        }
      });
    }
  }

  function setPartnerIntent(active) {
    if (active && !isPartner) {
      onToggleIntent(partnerIntent);
    }

    if (!active && isPartner) {
      onToggleIntent(partnerIntent);
    }
  }

  return (
    <Overlay isVisible={saving}>
      <div className="flex flex-col space-x-0 space-y-6">
        <Intent
          title={title}
          onClick={() => {
            isPartner ? setPartnerIntent(false) : onSubmit();
          }}
          // selected={!isPartner}
          selected={false}
        />
      </div>
    </Overlay>
  );
}
